import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

import type { DashboardsUrlMap, TwigContext } from './types'

const Reporting = lazy(() => import('./Reporting'))
const RootProviders = lazy(() => import('@app/components/AppProviders'))

class ReportingHeaderWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return [
      'dashboardsUrlMap',
      'totalKeys',
      'maintenanceModeEnabled',
      'maintenanceStartDate',
      'maintenanceEndDate',
    ]
  }

  override render() {
    const metabaseBaseUrl = this.prop('metabaseBaseUrl')
    const dashboardsUrlMap = this.jsonProp<DashboardsUrlMap>('dashboardsUrlMap') ?? {}
    const totalKeys = Number(this.prop('totalKeys'))

    const maintenanceBannerEnabled = Boolean(this.prop('maintenanceBannerEnabled'))
    const maintenanceModeEnabled = Boolean(this.prop('maintenanceModeEnabled'))

    // Expect dates to be in form of UNIX timestamp (UTC)
    const maintenanceStartTimestamp = Number(this.prop('maintenanceStartTimestamp'))
    const maintenanceEndTimestamp = Number(this.prop('maintenanceEndTimestamp'))

    const twigContext: TwigContext = {
      metabaseBaseUrl,
    }

    return (
      <RootProviders twigContext={twigContext}>
        <Reporting
          totalKeys={totalKeys}
          dashboardsUrlMap={dashboardsUrlMap}
          maintenanceBannerEnabled={maintenanceBannerEnabled}
          maintenanceModeEnabled={maintenanceModeEnabled}
          maintenanceStartTimestamp={maintenanceStartTimestamp}
          maintenanceEndTimestamp={maintenanceEndTimestamp}
        />
      </RootProviders>
    )
  }
}

customElements.define('reporting-header', ReportingHeaderWebComponent)
